import { FundTableComponent } from '../components/shared/fund-table/fund-table.component';
import { NgModule } from '@angular/core';
import { SharedComponentsModule } from '../../shared/module/shared-components.module';
import { TeamTableComponent } from '../components/shared/team-table/team-table.component';
import { TeamModalCrudComponent } from '../components/shared/team-modal-crud/team-modal-crud.component';
import { ModalFundUpdateComponent } from '../components/shared/modal-fund-update/modal-fund-update.component';
import { ModalFundTermComponent } from '../components/shared/modal-fund-term/modal-fund-term.component';
import {
  ModalOrganizationUpdateComponent,
} from '../components/shared/modal-organization-update/modal-organization-update.component';
import { TeamComponent } from '../components/management/team/team.component';
import { OrganizationInfoCardComponent } from '../components/shared/organization-info-card/organization-info-card.component';
import { OrgPpFundsOverviewComponent } from "../components/org-pp-funds-overview/org-pp-funds-overview.component";
import {
  OrganizationOverviewComponent,
} from "../components/organization-overview/component/organization-overview.component";
import {
  FundsSelectorDropdownComponent,
} from "../../shared/component/funds-selector-dropdown/funds-selector-dropdown.component";
import {
  TableGroupIconComponent,
} from "../../shared/component/icons-deprecated/table-group-icon/table-group-icon.component";

@NgModule({
  declarations: [
    FundTableComponent,
    TeamTableComponent,
    TeamModalCrudComponent,
    ModalFundUpdateComponent,
    ModalFundTermComponent,
    OrganizationInfoCardComponent,
    ModalOrganizationUpdateComponent,
    TeamComponent,
    OrgPpFundsOverviewComponent,
    OrganizationOverviewComponent,
  ],

  imports: [SharedComponentsModule, FundsSelectorDropdownComponent, TableGroupIconComponent],

  exports: [
    FundTableComponent,
    TeamTableComponent,
    TeamModalCrudComponent,
    ModalFundUpdateComponent,
    ModalFundTermComponent,
    OrganizationInfoCardComponent,
    ModalOrganizationUpdateComponent,
    TeamComponent,
    OrganizationOverviewComponent,
    OrgPpFundsOverviewComponent,
  ],
})
export class OrganizationSharedModule {}
